import styled from 'styled-components';

export const SignatureValidationContainer = styled.div`
  min-height: 100vh;
  padding: 32px 16px 48px;
  background:
    radial-gradient(
      circle at 12% 18%,
      rgba(34, 197, 94, 0.14),
      transparent 28%
    ),
    radial-gradient(
      circle at 88% 4%,
      rgba(14, 165, 233, 0.16),
      transparent 32%
    ),
    linear-gradient(145deg, #f8fafc 0%, #eff6ff 45%, #f0fdf4 100%);

  .validation-shell {
    width: 100%;
    max-width: 1120px;
    margin: 0 auto;
    display: grid;
    gap: 20px;
  }

  .hero-card,
  .form-card,
  .result-card {
    border-radius: 24px;
    box-shadow: 0 18px 50px rgba(15, 23, 42, 0.08);
    border: 1px solid rgba(148, 163, 184, 0.14);
    overflow: hidden;
  }

  .hero-card {
    padding: 28px;
    background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.96),
      rgba(248, 250, 252, 0.9)
    );
    backdrop-filter: blur(10px);
  }

  .hero-badge {
    width: fit-content;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 14px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #0f766e;
    background: rgba(20, 184, 166, 0.12);
    margin-bottom: 18px;
  }

  .hero-grid {
    display: grid;
    grid-template-columns: minmax(0, 1.5fr) minmax(280px, 0.9fr);
    gap: 20px;
    align-items: start;
  }

  .hero-title.ant-typography {
    margin-bottom: 12px;
    color: #0f172a;
    max-width: 720px;
  }

  .hero-description.ant-typography {
    margin-bottom: 22px;
    font-size: 16px;
    line-height: 1.7;
    color: #475569;
    max-width: 700px;
  }

  .hero-steps {
    display: grid;
    gap: 12px;
  }

  .step-item {
    display: grid;
    grid-template-columns: 40px 1fr;
    gap: 14px;
    align-items: start;
    padding: 14px 16px;
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.86);
    border: 1px solid rgba(148, 163, 184, 0.16);
  }

  .step-item strong {
    display: block;
    margin-bottom: 4px;
    color: #0f172a;
  }

  .step-item p {
    margin: 0;
    color: #64748b;
  }

  .step-number {
    width: 40px;
    height: 40px;
    border-radius: 14px;
    display: grid;
    place-items: center;
    font-weight: 700;
    color: #0369a1;
    background: linear-gradient(
      135deg,
      rgba(14, 165, 233, 0.18),
      rgba(59, 130, 246, 0.12)
    );
  }

  .help-card {
    border-radius: 22px;
    background: linear-gradient(180deg, #0f172a 0%, #1e293b 100%);
    color: #e2e8f0;
  }

  .help-label.ant-typography {
    display: block;
    margin-bottom: 4px;
    color: #7dd3fc;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }

  .help-text.ant-typography {
    margin-bottom: 0;
    color: #e2e8f0;
  }

  .form-card,
  .result-card {
    background: rgba(255, 255, 255, 0.94);
  }

  .section-header {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    align-items: flex-start;
    margin-bottom: 8px;
  }

  .section-title.ant-typography {
    margin-bottom: 2px;
    color: #0f172a;
  }

  .section-description {
    color: #64748b;
  }

  .section-tag {
    margin: 0;
    border-radius: 999px;
    padding: 6px 12px;
    font-weight: 600;
  }

  .ant-form-item {
    margin-bottom: 18px;
  }

  .ant-input,
  .ant-select-selector {
    border-radius: 14px !important;
    min-height: 46px !important;
  }

  .ant-select-selector {
    padding-top: 6px !important;
  }

  .form-actions {
    display: flex;
    justify-content: flex-start;
    margin-top: 8px;
  }

  .form-actions .ant-btn {
    height: 48px;
    padding: 0 22px;
    border-radius: 14px;
    font-weight: 600;
    box-shadow: 0 12px 26px rgba(37, 99, 235, 0.18);
  }

  .loading-state {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 20px;
    border-radius: 18px;
    background: rgba(241, 245, 249, 0.8);
  }

  .feedback-alert {
    margin-top: 20px;
    border-radius: 16px;
  }

  .result-card {
    border-top: 4px solid var(--status-color);
  }

  .result-header {
    display: grid;
    grid-template-columns: 48px 1fr;
    gap: 14px;
    align-items: start;
  }

  .result-status-icon {
    width: 48px;
    height: 48px;
    border-radius: 16px;
    display: grid;
    place-items: center;
    background: color-mix(in srgb, var(--status-color) 14%, white);
  }

  .result-title.ant-typography {
    margin-bottom: 4px;
    color: var(--status-color);
  }

  .result-message.ant-typography {
    margin-bottom: 0;
    color: #475569;
  }

  .result-grid,
  .checks-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
  }

  .result-grid {
    margin-top: 24px;
  }

  .result-item,
  .check-card {
    padding: 16px;
    border-radius: 18px;
    background: #f8fafc;
    border: 1px solid rgba(148, 163, 184, 0.14);
  }

  .result-label,
  .check-label {
    display: block;
    margin-bottom: 8px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #64748b;
  }

  .result-item strong,
  .check-card strong {
    color: #0f172a;
    font-size: 15px;
    line-height: 1.5;
  }

  .result-divider.ant-divider {
    margin: 24px 0;
  }

  .check-card {
    position: relative;
    min-height: 112px;
  }

  .check-icon {
    position: absolute;
    right: 16px;
    bottom: 16px;
    font-size: 20px;
  }

  .check-icon.success {
    color: #16a34a;
  }

  .check-icon.danger {
    color: #dc2626;
  }

  @media (max-width: 900px) {
    .hero-grid,
    .result-grid,
    .checks-grid {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 640px) {
    padding: 20px 12px 32px;

    .hero-card,
    .form-card,
    .result-card {
      border-radius: 20px;
    }

    .hero-card {
      padding: 20px;
    }

    .hero-title.ant-typography {
      font-size: 28px;
    }

    .section-header {
      flex-direction: column;
      align-items: flex-start;
    }

    .form-actions {
      width: 100%;
    }

    .form-actions .ant-btn {
      width: 100%;
    }
  }
`;
